export function activityAttribution(identity) {
    const subject = identity?.userId ?? null;
    const admin = identity?.impersonatedBy ?? null;
    const impersonating = Boolean(admin || identity?.impersonation);
    const actorType = impersonating
        ? 'admin_impersonation'
        : identity?.isSystem
            ? 'system'
            : !subject
                ? 'unknown'
                : identity?.isAdmin
                    ? 'admin'
                    : 'customer';
    return {
        impersonation: impersonating,
        impersonated_by: admin,
        actor_user_id: impersonating ? admin : subject,
        subject_user_id: subject,
        organization_id: identity?.organizationId ?? null,
        activity_actor_type: actorType,
        is_customer_activity: actorType === 'customer',
    };
}
//# sourceMappingURL=activity-attribution.js.map